module.exports = __webpack_public_path__ + "static/media/FinishTestingWarning.59f13cc8.svg";